import React, { FC, useCallback } from "react";
import { IUserTrainingCourseSummary } from "src/@types/ImpiricaPlatformApi";
import { ClientTrainingTOCSection } from "./ClientTrainingTOCSection";
import styles from "./ClientTrainingTOC.module.css";
import { Icon } from "src/components/icons/Icon";
import { CircleArrowRight } from "lucide-react";

type ClientTrainingTOCProps = {
	course: IUserTrainingCourseSummary;
	onLaunchQuiz?: () => void;
};

export const ClientTrainingTOC: FC<ClientTrainingTOCProps> = ({
	course,
	onLaunchQuiz,
}) => {
	return (
		<ul data-testid="client-training-toc" className={styles.toc}>
			{course.sections &&
				course.sections.map((section, index) => (
					<li key={index}>
						<ClientTrainingTOCSection section={section} />
					</li>
				))}
			{course.quizId && !course.quizComplete && (
				<li className={styles.takeQuizButton}>
					<button
						type="button"
						className="btn btn-outline-secondary"
						onClick={onLaunchQuiz}
					>
						Take the quiz{" "}
						<Icon
							style={{ verticalAlign: "center" }}
							icon={CircleArrowRight}
						/>
					</button>
				</li>
			)}
		</ul>
	);
};
